export const card = {
  presenterdby: "Presented by",
  upcoming: "Upcoming Topics",
};
